import axios from "axios";

export const fetchRetrospective = async (rootSpace: string, token?: string) => {
  return axios
    .get(
      `${process.env.REACT_APP_API_PATH}/users/retrospective-data?rootSpaceId=${rootSpace}`,
      {
        headers: {
          Authorization: token ? `Bearer ${token}` : "",
        },
      }
    )
    .then(({ data }) => {
      const { salasIluminadas } = data.summary || 0;
      const { salasClimatizadas } = data.summary || 0;
      const { consumoMedioFamiliar } = data.summary || 0;
      const { co2EvitadoTotal } = data.summary || 0;
      const { totalConsumoSomatorio } = data.summary || 0;
      const { percentualEnergiaVerde } = data.summary || 0;
      const { dispositivosOnline } = data.summary || 0;
      const { monthlyCO2 } = data || [];
      const { monthlyConsumptions } = data || [];
      return {
        salasIluminadas,
        salasClimatizadas,
        consumoMedioFamiliar,
        co2EvitadoTotal,
        monthlyCO2,
        totalConsumoSomatorio,
        percentualEnergiaVerde,
        dispositivosOnline,
        monthlyConsumptions,
      };
    });
};
